import React, { ReactElement } from 'react'
import Divider from '../Divider'
import ClaimsOverview from './ClaimsOverview'

const ClaimsPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <ClaimsOverview />
        </div>
    )
}

export default ClaimsPanel
